import { useEffect, useState } from "react";
import PubSub from 'pubsub-js';
import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
import moment from 'moment';
import { LeadAssignationLogService } from '../../Services';
import './AdminLeadAssignationLogs.css';

function AdminLeadAssignationLogs() {
    const [logs, setLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [isRefreshing, setIsRefreshing] = useState(false);

    useEffect(() => {
        getLeadAssignationLogs();
    }, []);

    async function getLeadAssignationLogs() {
        setIsLoading(true);
        setIsRefreshing(true);
        PubSub.publish('loading.notification', { message: 'Loading assignation logs...', show: true });

        try {
            const result = await LeadAssignationLogService.getRecentLeadAssignationLogs();
            setLogs(result.data || []);
            setHasLoaded(true);
        } catch (error) {
            console.error('Error:', error);
            PubSub.publish('show-basic-notification', {
                title: 'Error',
                message: 'Error loading assignation logs'
            });
            setHasLoaded(true);
        }
        PubSub.publish('loading.notification', { message: 'Loading assignation logs...', show: false });
        setIsLoading(false);
        
        // Detener la rotación después de un breve delay
        setTimeout(() => {
            setIsRefreshing(false);
        }, 1000);
    }

    function formatDate(dateString) {
        try {
            return moment(dateString).format('ll LTS');
        } catch (error) {
            return dateString;
        }
    }

    function renderSkeletonRow(index) {
        return (
            <tr key={index}>
                <td><div className="skeleton-text"></div></td>
                <td><div className="skeleton-text"></div></td>
                <td><div className="skeleton-text"></div></td>
                <td><div className="skeleton-text"></div></td>
                <td><div className="skeleton-text"></div></td>
            </tr>
        );
    }

    function renderLogRow(log, index) {
        return (
            <tr key={log._id || index}>
                <td>
                    <div className="d-flex align-items-center">
                        <Badge bg="primary" className="sequence-badge me-2">
                            {log.sequence?.name || 'N/A'}
                        </Badge>
                    </div>
                </td>
                <td className="user-info">
                    <div className="d-flex flex-column">
                        <strong>{log.sequence?.user?.name || 'N/A'}</strong>
                        <small className="text-muted">{log.sequence?.user?.email || 'N/A'}</small>
                    </div>
                </td>
                <td className="lead-info">
                    <div className="d-flex flex-column">
                        <strong>{log.lead?.name || 'N/A'}</strong>
                        <small className="text-muted">{log.lead?.email || 'N/A'}</small>
                        {log.lead?.organization_name && (
                            <small className="text-muted">{log.lead.organization_name}</small>
                        )}
                    </div>
                </td>
                <td className="date-info">
                    <span className="text-muted">
                        {formatDate(log.created_at)}
                    </span>
                </td>
                <td className="status-info">
                    <Badge bg="success">Assigned</Badge>
                </td>
            </tr>
        );
    }

    return (
        <div className="container-fluid mt-4 lead-assignation-logs-container">
            <div className="row">
                <div className="col-12">
                    <Card className="lead-assignation-logs-table">
                        <Card.Header className="lead-assignation-logs-header d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">
                                <i className="fas fa-list-alt me-2"></i>
                                Lead Assignation Logs
                            </h5>
                            <button
                                className="btn btn-outline-secondary btn-sm refresh-button"
                                onClick={getLeadAssignationLogs}
                                disabled={isLoading}
                            >
                                <i className={`fas fa-sync-alt me-1 ${isRefreshing ? 'rotating' : ''}`}></i>
                                Refresh
                            </button>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive">
                                <Table striped hover className="mb-0">
                                    <thead>
                                        <tr>
                                            <th>Campaign</th>
                                            <th className="user-info">User</th>
                                            <th className="lead-info">Lead</th>
                                            <th className="date-info">Assignation Date</th>
                                            <th className="status-info">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoading || !hasLoaded
                                            ? Array(5).fill(null).map((_, index) => renderSkeletonRow(index))
                                            : logs.length > 0
                                                ? logs.map((log, index) => renderLogRow(log, index))
                                                : (
                                                    <tr>
                                                        <td colSpan="5" className="empty-state">
                                                            <i className="fas fa-inbox fa-2x mb-3 d-block"></i>
                                                            No assignation logs available
                                                        </td>
                                                    </tr>
                                                )
                                        }
                                    </tbody>
                                </Table>
                            </div>

                            {hasLoaded && !isLoading && logs.length > 0 && (
                                <div className="text-center mt-3">
                                    <span className="logs-count">
                                        <i className="fas fa-info-circle me-1"></i>
                                        Showing {logs.length} assignation logs
                                    </span>
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </div>
    );
}

export default AdminLeadAssignationLogs;
